<!--
TODO: extract quill module events
- remove v-click-outside="hideDropdown" from outer container? (it emits a lot of times on click for large lists with dropdowns)
- simplify events management (now it mixed with popper.js/bootstrap and manual ones)
 -->
<template>
    <div class="dropdown d-inline-block"
         tabindex="-1"
         :id="id"
         :ref="id"
         v-click-outside="hideDropdown"
         @keyup.esc="onEscape"
         @keydown="(e) => $emit('keyDown', e)"
         @keydown.enter.prevent="onEnter"
         @keydown.up.prevent="onKeyUp"
         @keydown.down.prevent="onKeyDown">

        <div v-if="showMenuButton"
             :id="`dropdown-menu-btn-${id}`"
             @click="toggleShow"
             :data-toggle="disabled ? '' : 'dropdown'"
             data-boundary="viewport"
             aria-haspopup="true"
             aria-expanded="false"
             class="dropdown-toggle text-muted w-100 text-left">

            <slot name="menu-button"></slot>

        </div>

        <div v-if="!disabled"
             @blur.capture="hideDropdown"
             tabindex="-2"
             :id="`dropdown-${id}`"
             class="dropdown-menu"
             :class="{
                 'dropdown-menu-left': align === 'left',
                 'dropdown-menu-right':  align === 'right',
                 'd-block': !showMenuButton || (dropdown && stopPropagation)
             }">

            <div v-if="search && search.show" class="form-group has-search">
                <span class="search-icon">
                    <i class="fal fa-search"></i>
                </span>
                <input
                    v-model="query"
                    :ref="`query_${id}`"
                    type="search"
                    class="form-control form-control-sm search-input"
                    placeholder="Search">
            </div>

            <slot name="header"></slot>

            <div v-if="dropdown" class="items-list">
                <small v-if="filteredData.length === 0" class="text-muted p-3">
                    No items
                </small>
                <template v-else>
                    <template v-if="isGroupedValues">

                        <!-- TODO: slot for group label to allow customization -->
                        <div v-for="(group, groupIdx) in groups" :key="group.key">
                            <span class="font-12 text-muted p-3">{{ group.label }}</span>

                            <a v-for="(item, itemIdx) in getGroupItems(group.key)" :key="itemIdx"
                               @click.prevent="setItem(item, $event)"
                               :class="{ 'highlighted-item': groupIdx === hg && itemIdx === hi }"
                               class="dropdown-item pl-4">

                                <slot name="item" :item="item"></slot>

                            </a>
                        </div>
                    </template>
                    <template v-else>
                        <a v-for="(item, idx) in filteredData" :key="idx"
                           @click.prevent="setItem(item, $event)"
                           :class="{ 'highlighted-item': idx === hi }"
                           class="dropdown-item">

                            <slot name="item" :item="item"></slot>

                        </a>
                    </template>
                </template>
            </div>

            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
/*
 TODO: replace with AppSelect,
       improve props interface,
       remove search props - use slots instead
       TS
*/
export default {
    name: 'AppDropdown',
    props: {
        id: {
            type: String,
            required: true
        },
        data: {
            required: true,
            type: Array
        },
        showMenuButton: {
            type: Boolean,
            default: true
        },
        hideOnSelect: {
            type: Boolean,
            default: true
        },
        stopPropagation: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        search: {
            type: Object
            // show: Boolean,
            //
            // property: String
            // caseSensitive: false
            // or
            // searchFunction: Function = (item, query) => item[property].includes(query)
        },
        withQuillModuleEvents: {
            type: Boolean,
            default: false
        },
        align: {
            type: String,
            required: false,
            default: 'left' // 'right'
        },
        groupByLabelProp: { // TODO: function | propKey
            type: String,
            required: false
        },
        groupByProp: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            dropdown: false,
            hi: 0, // highlighted item index
            hg: 0, // highlighted group index
            query: ''
        }
    },
    computed: {
        filteredData() {
            if (this.search && this.query) {
                if (typeof this.search.searchFunction === 'function') {
                    return this.search.searchFunction(this.query, this.data)
                }
                return this.data.filter(item => {
                    if (this.search.caseSensitive) {
                        return !!item[this.search.property].includes(this.query)
                    } else {
                        return !!item[this.search.property].toLowerCase().includes(this.query.toLowerCase())
                    }
                })
            } else {
                return this.data
            }
        },

        isGroupedValues() {
            return this.groupByLabelProp && this.groupByProp
        },

        groups() {
            if (!this.isGroupedValues) {
                return []
            }
            return _.uniqBy(this.filteredData, this.groupByProp).map(item => ({
                key: item[this.groupByProp],
                label: item[this.groupByLabelProp]
            }))
        }
    },
    methods: {
        hideDropdown(event) {
            if (!this.dropdown ||
                event.relatedTarget !== null) { // prevent blur on child dropdown events
                return
            }
            this.$emit('dropdown-hide')
            this.dropdown = false
        },

        toggleShow(event) {
            if (this.stopPropagation) {
                event.stopPropagation()
            }
            if (this.disabled) {
                return
            }
            this.dropdown = !this.dropdown
            this.$emit('triggerBtnClick')
        },

        setItem(item, event) {
            if (event && this.stopPropagation) {
                event.stopPropagation()
            }
            this.$emit('select', item)
            if (this.hideOnSelect) {
                this.dropdown = false
            }
            this.query = ''
            if (this.withQuillModuleEvents) {
                this.$bus.$emit('QUILL_FOCUS')
            }
        },

        onEscape() {
            if (this.withQuillModuleEvents) {
                this.$bus.$emit('QUILL_CLEAR_EXECUTED_COMMAND')
            }
            this.dropdown = false
        },

        onEnter() {
            if (this.filteredData[this.hi]) {
                this.setItem(this.filteredData[this.hi])

                if (this.hideOnSelect) {
                    this.menuBtnClick()
                }
            }
        },

        // TODO: correct keyup and down handlers for grouped values
        onKeyUp() {
            if (this.dropdown) {
                if (this.hi === 0) {
                    this.hi = this.filteredData.length - 1
                } else {
                    this.hi--
                }
            }
        },

        onKeyDown() {
            if (this.dropdown) {
                if (this.hi === this.filteredData.length - 1) {
                    this.hi = 0
                } else {
                    this.hi++
                }
            }
        },

        menuBtnClick() {
            // NOTE: with popper js (for reposition dropdown in scrolled div)
            const el = document.getElementById(`dropdown-menu-btn-${this.id}`)
            if (el) {
                el.click()
            }
        },

        getGroupItemRealIndex(item) {
            return this.filteredData.findIndex(el => _.isEqual(el, item))
        },

        getGroupItems(groupKey) {
            return this.filteredData.filter(item => item[this.groupByProp] === groupKey)
        }
    },
    mounted() {
        if (!this.showMenuButton) {
            this.dropdown = true
        }

        if (this.withQuillModuleEvents) {
            this.$bus.$on('QUILL_HOT_KEY_PRESSED_2', keyCode => {
                switch (keyCode) {
                case 13: // enter
                    this.onEnter()
                    break
                case 38: // arrow up
                    this.onKeyUp()
                    break
                case 27: // escape
                    this.onEscape()
                    break
                case 40: // arrow down
                    this.onKeyDown()
                    break
                }
            })
        }

        this.$bus.$on(`APP_DROPDOWN_OPEN_${this.id}`, () => this.menuBtnClick())
        this.$bus.$on(`APP_DROPDOWN_HIDE_${this.id}`, () => {
            if (this.dropdown) {
                this.menuBtnClick()
            }
        })
    },
    beforeDestroy() {
        if (this.withQuillModuleEvents) {
            this.$bus.$off('QUILL_HOT_KEY_PRESSED_2')
        }
        this.$bus.$off(`APP_DROPDOWN_OPEN_${this.id}`)
        this.$bus.$off(`APP_DROPDOWN_HIDE_${this.id}`)
    },
    watch: {
        dropdown(val) {
            if (val) {
                if (this.search && this.search.show) {
                    window.setTimeout(() => { // focus bag
                        if (this.$refs[`query_${this.id}`]) {
                            this.$refs[`query_${this.id}`].focus()
                        }
                    }, 0)
                }
            }
        },
        filteredData(val) {
            this.hi = val.length === 0 ? -1 : 0
        },
        query() {
            // Avoid the dropdown "flight" (as the height may change when searching)
            $('.dropdown-toggle').dropdown('update')
        }
    }
}
</script>

<style scoped lang="scss">
.highlighted-item {
    background: $color-purple-soft !important;
}

.dropdown-menu {
    padding: 9px;

    &:focus {
        outline: 0 solid transparent !important;
    }
}

.items-list {
    max-height: 220px;
    min-width: 120px;
    overflow-y: auto;
}

.search-input {
    border-radius: 2px;
    padding-left: 24px;
    border: solid 1px #e9eaf0;
    background-color: #f4f5f7;
    margin-bottom: 8px;

    &:focus {
        box-shadow: none !important;
        outline: none !important;
    }
}

.has-search {
    padding: 0;
    width: 100%;
    margin-bottom: 0;
}

.search-icon {
    position: absolute;
    left: 12px;
    line-height: 33px;
    font-size: 14px;
    z-index: 2;
    display: block;
    width: 18px;
    height: 18px;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}

.dropdown-item {
    padding: 4px 8px;
    font-size: 14px;
    color: $color-dark;
}

// hide arrow down
.dropdown-toggle:after {
    display: none;
}
</style>
